export default __webpack_public_path__ + "static/media/devices_wdc.0e37a8bb.svg";